/* eslint-env browser, amd */
/*
	You can explicitly add some Boostrap JS modules
*/
require('bootstrap/dist/js/bootstrap.js');
//require('bootstrap/dist/js/umd/carousel.js');
//require('bootstrap/dist/js/umd/modal.js');

// Main entry point for gulp build-js.js tasks using webpack

require('tether/dist/js/tether.js');
//require('./scrollto.js');
require('./inline-svg.js');
require('./owlcarousel.js');
//require('./gmap.js');
//require('./leaflet.js');
//require('./masonry.js');
//require('./cookiebar.js');
//require('./ie10-viewport-bug-workaround.js');
//require('./bootstrap-popover.js');
require('./bootstrap-collapse.js');
//require('./object-fit.js');
//require('./progressbar.js');
//require('./reading-time.js');
//require('./carousel-in-modal.js'); 
require('./scroll-trigger.js');
//require('./tab-to-accordion.js');
//require('./fontsize.js');
//require('./contrast.js'); 
require('./header-shrink.js');
require('./doubleclick.js');
require('./flipcard.js');
//require('./home.js');
require('./menu.js');



//////////////////
// WEBPACK FOOTER
// ./source/javascript/es5/main.js
// module id = 0
// module chunks = 0